export const WISH_LIST_DEFAULT_LIMIT = 20

export type WishListStatus = 'Waiting' | 'Available' | 'OrderConfirmed'

export const withWishListPaginationParams = (params?: IWishListParams): IWishListParams => ({
  limit: WISH_LIST_DEFAULT_LIMIT,
  offset: 1,
  ...params,
})

export interface IWishListParams {
  userId?: number
  companyName?: string
  productCode?: string
  displayName?: string
  makerName?: string
  carName?: string
  carModel?: string
  engineModel?: string
  stockType?: string
  stockSource?: string
  status?: WishListStatus
  isAvailable?: boolean
  limit?: number
  offset?: number
}

export interface IWishListRow {
  id: string
  refNo: string
  productCode: string
  productName: string
  displayName: string
  makerName: string
  carName: string
  year?: number | null
  orderedAt?: number | null
  stockType: string
  stockSource: string
  carModel: string
  engineModel: string
  companyName: string
  userName: string
  createDate: number
  updateDate: number
  status?: WishListStatus
  isAvailable?: boolean
  withCatalyst?: boolean | null
  wishPrice?: string | null
}

export interface IWishListResponse {
  data: IWishListRow[]
  pagination: {
    currentPage: number
    limitValue: number
    totalCount: number
    totalPages: number
  }
}
